/**
 * Component: M33 Form
 * 
 */
'use strict';

export class Form
{
  constructor()
  {
    this.selectors = {
      component:        $('.c-v4-m33-form'),
      pre_form_wrapper: $('.c-v4-m33-form--form-pre'),
      pre_form:         $('form.sysdig-form-pre'),
      form_wrapper:     $('.c-v4-m33-form--form-main'),
      form:             $('.c-v4-m33-form--form form.sysdig-form')
    };
  }
  
  init()
  {
    if ( ! this.selectors.component.length ) return;

    let _self = this,
        email = localStorage.getItem('sysdig_email'),
        phone = localStorage.getItem('sysdig_phone');

    if ( email !== null )
    {
      MktoForms2.whenReady(function (form)
      { 
        $('input[type=email]', _self.selectors.form).val(email);
        $('input[type=tel]', _self.selectors.form).val(phone);

        _self.selectors.pre_form_wrapper.addClass('hidden');
        _self.selectors.form_wrapper.removeClass('hidden');
      });
    }
    else if ( this.selectors.pre_form )
    {
      this.selectors.pre_form.on('submit', function( e )
      {
        e.preventDefault();

        let email = $('input[type=email]', $(this)).val(),
            phone = $('input[type=tel]', $(this)).val();

        $('input[type=email]', _self.selectors.form).val(email);
        $('input[type=tel]', _self.selectors.form).val(phone);

        localStorage.setItem('sysdig_email', email);

        if ( phone && phone != '' )
        {
          localStorage.setItem('sysdig_phone', phone);
        }

        _self.selectors.pre_form_wrapper.addClass('hidden');
        _self.selectors.form_wrapper.removeClass('hidden');
      });
    }
  }
}